import {
  getPathname,
  matchesElementaryProductPath,
  matchesHighSchoolProductPath,
  matchesMiddleSchoolProductPath,
} from 'utils/routing/routeHelpers'
import {
  HS_TRAINING_COURSE_CODE,
  K5_TRAINING_COURSE_CODE,
  MS_TRAINING_COURSE_CODE,
} from './constants'

/**
 * Resolves the active K12 training program from the current URL.
 * @param {string} [pathname]
 * @returns {{ type: 'highSchool'|'k5'|'middleSchool'|null, programKey: string|null, courseTreeName: string|null }}
 */
export const resolveK12TrainingProgramFromUrl = (pathname = getPathname()) => {
  if (matchesHighSchoolProductPath(pathname)) {
    return {
      type: 'highSchool',
      programKey: 'highSchool',
      courseTreeName: HS_TRAINING_COURSE_CODE,
    }
  }

  if (matchesMiddleSchoolProductPath(pathname)) {
    return {
      type: 'middleSchool',
      programKey: 'mspDigital',
      courseTreeName: MS_TRAINING_COURSE_CODE,
    }
  }

  if (matchesElementaryProductPath(pathname)) {
    return {
      type: 'k5',
      programKey: 'k5SelDigital',
      courseTreeName: K5_TRAINING_COURSE_CODE,
    }
  }

  return {
    type: null,
    programKey: null,
    courseTreeName: null,
  }
}

/**
 * Returns the training course tree for the resolved program.
 * @param {Object} courseManager
 * @param {{ courseTreeName: string|null }} program
 */
export const getTrainingCourseTree = (courseManager, program) => {
  const { courseTreeName } = program || {}
  if (!courseTreeName || !courseManager?.courseTrees) {
    return null
  }

  return courseManager.courseTrees[courseTreeName] || null
}

/**
 * Maps a resolved program type to the LMS instructor-data selector key.
 * @param {'highSchool'|'k5'|'middleSchool'|null} type
 * @returns {'hs'|'middleSchool'|'k5'|null}
 */
export const getInstructorDataSelectorKeyForProgram = type => {
  switch (type) {
    case 'highSchool':
      return 'hs'
    case 'middleSchool':
      return 'middleSchool'
    case 'k5':
      return 'k5'
    default:
      return null
  }
}
